import { globalConstants } from '../constants';

const initialState = {
  courts: []
};

export function global(state = initialState, action) {
  switch (action.type) {
    case globalConstants.START_LOADING:
      return {
        ...state,
        loading: true
      };
    case globalConstants.STOP_LOADING:
      return {
        ...state,
        loading: false
      };
    case globalConstants.LOADCONFIG_SUCCESS:
      return {
        ...state,
        config: action.res
      };
    case globalConstants.LOADCOURTS_SUCCESS:
      return {
        ...state,
        courts: action.res
      };
    default:
      return state
  }
}